import React from "react";
import FormattedDate from "./formattedDate";
import Temperature from "./temperature"
export default function WeatherInfo (props) {
return(
    <div className="WeatherInfo">

<h1>{props.data.city}</h1>
    <ul>
        <li><FormattedDate date={props.data.date}/></li>
        <li className="text-capitalize">{props.data.description}</li>
    </ul>

    <div className="row mt-3">
        <div className="col-6">
        <div className="d-flex">
            <img src={props.data.icon_url} 
            className ="" 
            alt={props.data.description}/>
            <Temperature celcius={props.data.temperature}/>
            
        </div>
        </div>
        <div className="col-6">
            <ul>
            <li>Pressure: {props.data.pressure}hPa</li>
                <li>Humidity: {props.data.humidity}%</li>
                <li>Wind: {props.data.wind}km/h</li>
            </ul>
        </div>    
    </div>
    </div>);
}
